import React from 'react';

import Layout from '../../components/Layout';
import InquiriesForm from './InquiriesForm';
import InfoLinks from './InfoLinks';
import styles from './styles.module.css';

const Inquiries = () => (
  <Layout pageTitle="Inquiries - FabFitFun">
    <div className={styles.page}>
      <div className={styles.content}>
        <section className={styles.inquiries}>
          <h1 className={styles['inquiries-h1']}>Inquiries</h1>
          <InfoLinks />
          <h2 className={styles['inquiries-h2']}>Brand and Product Partnerships</h2>
          <p>
            Have an amazing company or product and want to work with us? Know of a great brand we should work with?
            Please fill out the following
            <b>form</b>
            .
          </p>
          <InquiriesForm />
        </section>
      </div>
    </div>
  </Layout>
);

export default Inquiries;
